import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions, isLanguageLoaded, languageSelector, loadLanguageMessages } from 'redux/modules/locale';

/**
 * Loads the messages of the chosen language when they are not in the main chunk (Russian, Chinese); the messages
 * are shown in English meanwhile. Renders nothing.
 */
const LocaleLoader = () => {
    const language: string = useSelector(languageSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isLanguageLoaded(language)) return undefined;

        let active = true;
        loadLanguageMessages(language)
            .then(() => {
                if (active) dispatch(actions.languageLoaded(language));
            })
            .catch((error: unknown) => {
                // eslint-disable-next-line no-console -- the page stays in English; the details are for debugging
                console.error(`Loading the ${language} messages failed:`, error);
            });

        return () => {
            active = false;
        };
    }, [language, dispatch]);

    return null;
};

export default LocaleLoader;
